var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetAudienceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.99997,
    cy: 8.99997,
    r: 5.61765,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5294 9.5C16.8055 9.5 17.0294 9.27614 17.0294 9C17.0294 8.72386 16.8055 8.5 16.5294 8.5V9.5ZM12.7646 8.5C12.4885 8.5 12.2646 8.72386 12.2646 9C12.2646 9.27614 12.4885 9.5 12.7646 9.5L12.7646 8.5ZM16.5294 8.5H12.7646L12.7646 9.5H16.5294V8.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.5294C8.5 16.8056 8.72386 17.0294 9 17.0294C9.27614 17.0294 9.5 16.8056 9.5 16.5294L8.5 16.5294ZM9.5 12.7647C9.5 12.4886 9.27614 12.2647 9 12.2647C8.72386 12.2647 8.5 12.4886 8.5 12.7647L9.5 12.7647ZM9.5 16.5294L9.5 12.7647L8.5 12.7647L8.5 16.5294L9.5 16.5294Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23529 9.5C5.51143 9.5 5.73529 9.27614 5.73529 9C5.73529 8.72386 5.51143 8.5 5.23529 8.5V9.5ZM1.47058 8.5C1.19444 8.5 0.970581 8.72386 0.970581 9C0.970581 9.27614 1.19444 9.5 1.47058 9.5L1.47058 8.5ZM5.23529 8.5H1.47058L1.47058 9.5H5.23529V8.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.23529C8.5 5.51143 8.72386 5.73529 9 5.73529C9.27614 5.73529 9.5 5.51143 9.5 5.23529L8.5 5.23529ZM9.5 1.47058C9.5 1.19444 9.27614 0.970581 9 0.970581C8.72386 0.970581 8.5 1.19444 8.5 1.47058L9.5 1.47058ZM9.5 5.23529L9.5 1.47058L8.5 1.47058L8.5 5.23529L9.5 5.23529Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetAudienceIcon);
export default __webpack_public_path__ + "static/media/target-audience-icon.8f72b968158b04174f61f800ede85fd0.svg";
export { ForwardRef as ReactComponent };